import {
  boolean,
  type InferOutput,
  number,
  object,
  optional,
  picklist,
  string
} from 'valibot'

import {
  createSorterSchema,
  CONTRACTS_SORT_KEYS
} from '@/features/shared/models'
import { CONTRACT_TYPE_SELECTABLE } from '@/libs/api/types'

export const ContractsSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(CONTRACTS_SORT_KEYS),
  dcId: optional(number()),
  name: optional(string()), // 契約名
  partnerId: optional(number()), // パートナー
  // 契約種別（個建は #5551 で入口を閉じたため、URL 直指定の TANKA も受け付けない）
  contractType: optional(picklist(CONTRACT_TYPE_SELECTABLE)),
  startSiteId: optional(number()), // 開始地点
  destinationSiteId: optional(number()), // 配送先地点
  isApplying: optional(boolean()) // 適用期間
})

export type ContractsSearch = InferOutput<typeof ContractsSearchSchema>
